import { render, staticRenderFns } from "./DomainModal.vue?vue&type=template&id=d63643c8&scoped=true"
import script from "./DomainModal.vue?vue&type=script&lang=js"
export * from "./DomainModal.vue?vue&type=script&lang=js"
import style0 from "./DomainModal.vue?vue&type=style&index=0&id=d63643c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d63643c8",
  null
  
)

export default component.exports